import React from "react";
import { useHistory } from "react-router-dom";
import * as ROUTES from "../../constans/rutas";
import logo from "../../asses/img/parkingl.png";
import "./PlanillasHome.css";

const PlanillasHome = () => {
  const history = useHistory();

  return (
    <div className="planillas-home">
      <div className="planillas-encabezado">
        <div className="planillas-marca">
          <img src={logo} alt="Parking" />
          <h1 className="planillas-title">Panel Principal</h1>
        </div>
        <button
          type="button"
          className="planillas-back"
          onClick={() => history.push(ROUTES.HOME)}
        >
          Inicio
        </button>
      </div>
      <div className="home-module-grid w-full max-w-6xl mx-auto">
        <div
          className="custom-card"
          onClick={() => history.push(ROUTES.PLANILLAS_MODIFICA_RECAUDO)}
        >
          <div className="card-body">
            <div className="card-icon blue">
              <svg
                className="icon"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>
            <h5 className="card-title">Eliminación de turnos</h5>
            <p className="card-text">
              Click aqui para solucionar planilla con turnos mal reportados
            </p>
          </div>
        </div>

        <div
          className="custom-card"
          onClick={() => history.push(ROUTES.PLANILLAS_CIERRE_DIA)}
        >
          <div className="card-body">
            <div className="card-icon green">
              <svg
                className="icon"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                />
              </svg>
            </div>
            <h5 className="card-title">Liberar factura</h5>
            <p className="card-text">Click aquí para liberar factura</p>
          </div>
        </div>

        <div
          className="custom-card"
          onClick={() => history.push(ROUTES.PLANILLAS_TRANSACCIONAL)}
        >
          <div className="card-body">
            <div className="card-icon purple">
              <svg
                className="icon"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                />
              </svg>
            </div>
            <h5 className="card-title">Validación Transaccional</h5>
            <p className="card-text">
              Click aquí para consultar y validar transacciones (transaccional)
            </p>
          </div>
        </div>

        <div
          className="custom-card"
          onClick={() => history.push(ROUTES.PLANILLAS_AJUSTE_FECHA)}
        >
          <div className="card-body">
            <div className="card-icon purple">
              <svg
                className="icon"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M8 7v10m8-10v10M5 7h14M5 17h14M4 5h16a1 1 0 011 1v12a1 1 0 01-1 1H4a1 1 0 01-1-1V6a1 1 0 011-1z"
                />
              </svg>
            </div>
            <h5 className="card-title">Ajuste de Fecha</h5>
            <p className="card-text">
              Click aquí para ingresar al módulo de ajuste de fecha
              (transaccional)
            </p>
          </div>
        </div>

        <div
          className="custom-card"
          onClick={() => history.push(ROUTES.PLANILLAS_TRASMITIR_GLOBAL)}
        >
          <div className="card-body">
            <div className="card-icon orange">
              <svg
                className="icon"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M12 19l9 2-9-18-9 18 9 2zm0 0v-8"
                />
              </svg>
            </div>
            <h5 className="card-title">Trasmitir a Global</h5>
            <p className="card-text">
              Click aquí para transmitir información al sistema global
            </p>
          </div>
        </div>

        <div
          className="custom-card"
          onClick={() => history.push(ROUTES.PLANILLAS_AJUSTE_MENSUALES)}
        >
          <div className="card-body">
            <div className="card-icon teal">
              <svg
                className="icon"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                />
              </svg>
            </div>
            <h5 className="card-title">Ajuste mensuales</h5>
            <p className="card-text">
              Click aquí para ingresar al módulo de ajustes mensuales
            </p>
          </div>
        </div>

        <div
          className="custom-card"
          onClick={() => history.push(ROUTES.PLANILLAS_EFECTIVO_DATAFONO)}
        >
          <div className="card-body">
            <div className="card-icon teal">
              <svg
                className="icon"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2h-2.5M9 19v-6m6 6v-6"
                />
              </svg>
            </div>
            <h5 className="card-title">Efectivo ↔ datáfono</h5>
            <p className="card-text">
              Traspaso entre total_efectivo y total_tc en cierre de turno
            </p>
          </div>
        </div>

        <div
          className="custom-card"
          onClick={() => history.push(ROUTES.AUDITORIA)}
        >
          <div className="card-body">
            <div className="card-icon slate">
              <svg
                className="icon"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
                />
              </svg>
            </div>
            <h5 className="card-title">Auditoria</h5>
            <p className="card-text">
              Click aquí para consultar los registros de audit_log
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlanillasHome;
